var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M4.7,16.7c0.3,0.6,0.9,1.1,1.6,1c1,0,2-0.3,2.7-1c7.8-7,19.7-6.8,27.3,0.5l0.9,0.7c1.2,0.8,2.5,0.6,3.1-0.2 c0.6-0.8,0.4-1.9-0.6-2.9C35,10.1,28.7,7.5,22.2,7.5C16,7.6,10.1,9.9,5.5,14L5,14.7C4.4,15.2,4.3,16,4.7,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M35.9,21.7c-0.2-0.5-0.5-1-1-1.4c-3.4-3-7.7-4.7-12.2-4.8c-4.5,0.1-8.7,1.9-11.9,5.1 c-0.5,0.4-0.8,0.9-1,1.5c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.9,0.6,1.8,1.6,1.8c0.9,0,1.7-0.3,2.3-0.9l1.3-1.1c5-3.9,12.1-3.6,16.8,0.7 c0.6,0.5,1.2,1,2,1.2c0.7,0.3,1.5,0.1,2-0.5C36.1,23.2,36.1,22.4,35.9,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.9,29c0.2-0.8-0.2-1.7-0.8-2.2C28.4,25,26,24,23.5,24c-2.7-0.1-5.4,0.7-7.6,2.3l-1.1,1.2 c-0.5,0.8-0.3,1.9,0.4,2.5c0.8,0.6,1.4,0.5,2.3-0.2c3-2.7,7.6-2.7,10.6,0.1c0.2,0.2,0.5,0.4,0.8,0.4C29.8,30.5,30.7,29.9,30.9,29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.9,37.5c0.8,0,1.5-0.3,2.1-0.8c0.5-0.6,0.9-1.4,0.9-2.2c0,0,0-0.1,0-0.1c0-1.7-1.3-3-3-3 c-1.7,0-3.1,1.4-3.1,3.1c0,0,0,0.1,0,0.1C19.8,36.2,21.2,37.5,22.9,37.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.0481d1bc1e67c252ef2eb69bc6808330.svg";
export { ForwardRef as ReactComponent };